import angular from 'angular';
import {
    dashboardPendingEventsReviewItemTemplate,
    dashboardPendingEventsReviewListItemTemplate
} from './dashboard-pending-events-review-templates.block';
import { DashboardPendingEventsReviewContainerComponent } from './dashboard-pending-events-review-container.component';
import { PendingEventsReviewComponent } from './pending-events-review.component';
import { DashboardScheduledEmployeesReviewContainerComponent } from './dashboard-scheduled-employees-review-container.component';


export const EventsSchedulingDashboardModule = angular
    .module("apex.mainApp.eventsScheduling.dashboard", [])
    .component("apexDashboardPendingEventsReviewContainer", DashboardPendingEventsReviewContainerComponent)
    .component("apexPendingEventsReview", PendingEventsReviewComponent)
    .component("apexDashboardScheduledEmployeesReviewContainer", DashboardScheduledEmployeesReviewContainerComponent)
    // Load dashboards into the template cache (compatibility for dashboard templates
    // whose paths are currently saved at the database level)
    .run(dashboardPendingEventsReviewItemTemplate)
    .run(dashboardPendingEventsReviewListItemTemplate)
    .name;
